import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractFirestoreDocResolver} from '@shared/services/abstracts/AbstractFirestoreDocResolver';
import {TransactionsRulesService} from "../services/transactionsRules.service";
import {TransactionRule} from "../models/transactionRule.interface";


@Injectable()
export class TransactionRuleResolver extends AbstractFirestoreDocResolver<TransactionRule> {

    constructor(route: ActivatedRoute, router: Router, service: TransactionsRulesService) {
        super(router, service);
    }
}
